import type { ReactNode } from 'react';

import type { HelpTopicId } from '@/shared/lib/help-topics';

import { HelpTip } from './HelpTip';
import styles from './HelpRow.module.css';

interface Props {
  /** The heading (or label) the explanation belongs to. */
  children: ReactNode;
  topic: string;
  /** The Help Center article this heading's tip belongs to (adds "Learn more"). */
  topicId?: HelpTopicId;
  /** A local explanation; without it the article's own short text is used. */
  text?: string;
}

/** A heading with its contextual "?" beside it (the heading's own name is left untouched). */
export function HelpRow({ children, topic, topicId, text }: Props) {
  return (
    <div className={styles.row}>
      {children}
      <HelpTip topic={topic} {...(topicId && { topicId })} {...(text !== undefined && { text })} />
    </div>
  );
}
